/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to send a single notification via Azure Communication Services
 * @export
 * @interface SingleNotificationRequest
 */
export interface SingleNotificationRequest {
    /**
     * Delivery channel: EMAIL or SMS
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    channel: string;
    /**
     * Recipient: email address for EMAIL, E.164 phone number for SMS
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    recipient: string;
    /**
     * Template ID from EMAIL_TEMPLATES config. If provided with variables, subject/body are resolved from template; otherwise use subject/bodyPlain/bodyHtml directly.
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    templateId?: string;
    /**
     * Variables for template substitution when templateId is used
     * @type {{ [key: string]: any; }}
     * @memberof SingleNotificationRequest
     */
    variables?: { [key: string]: any; };
    /**
     * Email subject (EMAIL only; ignored for SMS)
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    subject?: string;
    /**
     * HTML body (EMAIL only; optional)
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    bodyHtml?: string;
    /**
     * Plain text body (EMAIL or SMS; required for SMS)
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    bodyPlain?: string;
    /**
     * Tenant ID (optional; uses session tenant if not provided)
     * @type {string}
     * @memberof SingleNotificationRequest
     */
    tenantId?: string;
}

/**
 * Check if a given object implements the SingleNotificationRequest interface.
 */
export function instanceOfSingleNotificationRequest(value: object): value is SingleNotificationRequest {
    if (!('channel' in value) || value['channel'] === undefined) return false;
    if (!('recipient' in value) || value['recipient'] === undefined) return false;
    return true;
}

export function SingleNotificationRequestFromJSON(json: any): SingleNotificationRequest {
    return SingleNotificationRequestFromJSONTyped(json, false);
}

export function SingleNotificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SingleNotificationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'channel': json['channel'],
        'recipient': json['recipient'],
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'variables': json['variables'] == null ? undefined : json['variables'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'bodyHtml': json['bodyHtml'] == null ? undefined : json['bodyHtml'],
        'bodyPlain': json['bodyPlain'] == null ? undefined : json['bodyPlain'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
    };
}

export function SingleNotificationRequestToJSON(json: any): SingleNotificationRequest {
    return SingleNotificationRequestToJSONTyped(json, false);
}

export function SingleNotificationRequestToJSONTyped(value?: SingleNotificationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'channel': value['channel'],
        'recipient': value['recipient'],
        'templateId': value['templateId'],
        'variables': value['variables'],
        'subject': value['subject'],
        'bodyHtml': value['bodyHtml'],
        'bodyPlain': value['bodyPlain'],
        'tenantId': value['tenantId'],
    };
}

